import { motion } from "framer-motion";
import { ILLUSTRATIONS } from "@/lib/site";

export default function Gallery() {
  return (
    <section id="gallery" className="relative z-10 py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7 }}
          className="mb-14 max-w-2xl"
        >
          <p className="font-body text-sm uppercase tracking-[0.25em] text-gold">Inside the Book</p>
          <h2 className="mt-3 font-display text-4xl font-bold leading-tight text-cream md:text-5xl">
            Illustrations that glow with warmth
          </h2>
          <p className="mt-4 font-body text-lg text-slate-300">
            A peek at the tender, hand-crafted artwork from inside the book.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 gap-5 md:grid-cols-12 md:gap-6">
          {ILLUSTRATIONS.map((img, i) => (
            <motion.figure
              key={img.src}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: (i % 3) * 0.1, ease: [0.22, 1, 0.36, 1] }}
              data-testid={`gallery-item-${i}`}
              className={`group relative overflow-hidden rounded-2xl border border-white/10 bg-twilight-surface ${img.span}`}
            >
              <img
                src={img.src}
                alt={img.alt}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
              />
              <figcaption className="pointer-events-none absolute inset-x-0 bottom-0 translate-y-2 bg-gradient-to-t from-twilight/90 to-transparent p-5 font-body text-sm text-cream/90 opacity-0 transition-[opacity,transform] duration-500 group-hover:translate-y-0 group-hover:opacity-100">
                {img.alt}
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
